import { FaSearch } from "react-icons/fa";

/**
 * WhyDailyDishBar
 *
 * Pre-login only: white rounded bar shown under the free-meal banner with a
 * periodic golden shimmer sweep. Tapping it opens PreorderInfoModal
 * (handled by the parent via onClick).
 */
const WhyDailyDishBar = ({ onClick }) => (
  <div className="wdd-wrapper">
    <button type="button" className="wdd-bar" onClick={onClick}>
      <span className="wdd-icon">
        <FaSearch size={14} />
      </span>
      <span className="wdd-text">
        <span className="wdd-title">Why DailyDish?</span>
        <span className="wdd-sub">Fresh, home-cooked, made to order</span>
      </span>
      <span className="wdd-chevron">›</span>
      {/* golden shimmer sweep */}
      <span className="wdd-shine" aria-hidden="true" />
    </button>

    <style>{`
      .wdd-wrapper {
        max-width: 655px;
        width: 100%;
        margin: 0 auto;
        padding: 10px 16px 0;
        box-sizing: border-box;
      }
      .wdd-bar {
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        gap: 12px;
        width: 100%;
        background: #ffffff;
        border: 1px solid #ece6d6;
        border-radius: 14px;
        padding: 11px 16px;
        cursor: pointer;
        text-align: left;
        box-shadow: 0 3px 12px rgba(0, 0, 0, 0.1),
          inset 0 -2px 0 rgba(0, 0, 0, 0.04);
        transition: box-shadow 0.18s ease, transform 0.12s ease;
        -webkit-tap-highlight-color: transparent;
      }
      .wdd-bar:hover {
        box-shadow: 0 5px 16px rgba(0, 0, 0, 0.14);
      }
      .wdd-bar:active {
        transform: translateY(1px);
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);
      }
      .wdd-icon {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 34px;
        height: 34px;
        border-radius: 50%;
        background: #f2eee1;
        color: #4a3b6b;
      }
      .wdd-text {
        display: flex;
        flex-direction: column;
        gap: 2px;
        min-width: 0;
      }
      .wdd-title {
        font-size: 14px;
        font-weight: 700;
        color: #2c2c18;
        line-height: 1.2;
      }
      .wdd-sub {
        font-size: 12px;
        color: #8a8270;
        line-height: 1.3;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .wdd-chevron {
        margin-left: auto;
        flex-shrink: 0;
        font-size: 20px;
        line-height: 1;
        color: #b0a890;
        font-weight: 600;
      }
      .wdd-shine {
        position: absolute;
        top: 0;
        left: -80%;
        width: 55%;
        height: 100%;
        pointer-events: none;
        transform: skewX(-20deg);
        background: linear-gradient(
          115deg,
          transparent 0%,
          rgba(107, 142, 35, 0.25) 35%,
          rgba(107, 142, 35, 0.55) 50%,
          rgba(107, 142, 35, 0.25) 65%,
          transparent 100%
        );
        animation: wddShine 3.4s ease-in-out infinite;
      }
      @keyframes wddShine {
        0% { left: -80%; }
        45% { left: 130%; }
        100% { left: 130%; }
      }
    `}</style>
  </div>
);

export default WhyDailyDishBar;
